"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Provider;
exports.StoreContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _parseInt = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/parse-int"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _optionState = require("../components/Option/helpers/optionState");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StoreContext = /*#__PURE__*/_react["default"].createContext();

exports.StoreContext = StoreContext;

function initializeState(props) {
  var height = props.height,
      isMulti = props.isMulti,
      hasTag = props.hasTag,
      isOpen = props.isOpen,
      childrenOptions = props.childrenOptions,
      refFilterInput = props.refFilterInput,
      refFooterContainer = props.refFooterContainer,
      refListBox = props.refListBox,
      refListBoxContainer = props.refListBoxContainer,
      refTrigger = props.refTrigger,
      refTriggerContainer = props.refTriggerContainer; // initialize state for options and groups

  var _getDataOptions = (0, _optionState.getDataOptions)(childrenOptions),
      options = _getDataOptions.options,
      optionsIndex = _getDataOptions.optionsIndex;

  var selectedOptions = (0, _keys["default"])(options).filter(function (key) {
    return options[key].isSelected;
  }).map(function (key) {
    return (0, _parseInt["default"])(key, 10);
  });
  var activeOption = null;

  if (selectedOptions.length && !props.isMulti) {
    activeOption = selectedOptions[0];
  }

  var initialState = {
    activeOption: activeOption,
    filteredOptions: [],
    hasFilter: false,
    hasFooter: false,
    hasPopupOpened: false,
    hasTag: hasTag,
    height: height,
    isMulti: isMulti,
    isOpen: isOpen,
    lastKnownSelectedOptions: selectedOptions.slice(0),
    listBoxHasFocus: true,
    noResultsFound: false,
    onChangeFn: null,
    options: options,
    optionsIndex: optionsIndex,
    refFilterInput: refFilterInput,
    refFooterContainer: refFooterContainer,
    refListBox: refListBox,
    refListBoxContainer: refListBoxContainer,
    refTrigger: refTrigger,
    refTriggerContainer: refTriggerContainer,
    selectedOptions: selectedOptions,
    triggerWidth: 0
  };
  return _objectSpread(_objectSpread({}, initialState), {}, {
    originalState: _objectSpread({}, initialState)
  });
}

var propTypes = {
  children: _propTypes["default"].node.isRequired
};

function Provider(props) {
  var refFilterInput = _react["default"].useRef(null);

  var refFooterContainer = _react["default"].useRef(null);

  var refListBox = _react["default"].useRef(null);

  var refListBoxContainer = _react["default"].useRef(null);

  var refTrigger = _react["default"].useRef(null);

  var refTriggerContainer = _react["default"].useRef(null);

  var _React$useReducer = _react["default"].useReducer(_reducer["default"], _objectSpread(_objectSpread({}, props), {}, {
    refFilterInput: refFilterInput,
    refFooterContainer: refFooterContainer,
    refListBox: refListBox,
    refListBoxContainer: refListBoxContainer,
    refTrigger: refTrigger,
    refTriggerContainer: refTriggerContainer
  }), initializeState),
      _React$useReducer2 = (0, _slicedToArray2["default"])(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var value = {
    state: state,
    dispatch: dispatch
  };
  return /*#__PURE__*/_react["default"].createElement(StoreContext.Provider, {
    value: value
  }, props.children);
}

Provider.propTypes = propTypes;
//# sourceMappingURL=Provider.js.map